import { SubaccountsRepositoryImplementation } from '../infrastructure/subaccounts-repository-implementation';
import { Subaccount, UpdateSubaccountDto } from '../domain/subaccounts/repository';
import { Filter, PaginationData } from '@/domain/pagination/models';
import { ApiResponse } from '@/domain/pagination/models';

import { cacheManager } from '../infrastructure/cache-manager';

const repo = new SubaccountsRepositoryImplementation();
const CACHE_PREFIX = 'subaccounts';

async function getSubaccounts(page: number, limit: number, filters: Filter[] = []): Promise<ApiResponse<PaginationData<Subaccount[]>>> {
    const cacheKey = `${CACHE_PREFIX}-list-${page}-${limit}-${JSON.stringify(filters)}`;
    const cached = cacheManager.getItem<ApiResponse<PaginationData<Subaccount[]>>>(cacheKey);

    if (cached) {
        return cached;
    }

    const response = await repo.getSubaccounts(page, limit, filters).toPromise();
    if (!response) {
        throw new Error('Failed to fetch subaccounts');
    }

    cacheManager.setItem(cacheKey, response);
    return response;
}

async function updateSubaccount(id: number, data: UpdateSubaccountDto): Promise<ApiResponse<Subaccount>> {
    const response = await repo.updateSubaccount(id, data).toPromise();
    if (!response) {
        throw new Error('Failed to update subaccount');
    }
    cacheManager.invalidate(CACHE_PREFIX);
    return response;
}

async function deleteSubaccount(id: number): Promise<ApiResponse<void>> {
    const response = await repo.deleteSubaccount(id).toPromise();
    if (!response) {
        throw new Error('Failed to delete subaccount');
    }
    cacheManager.invalidate(CACHE_PREFIX);
    return response;
}

export { getSubaccounts, updateSubaccount, deleteSubaccount };
